// extracted by mini-css-extract-plugin
export default {"cta_wrapper":"cta_wrapper___Bo8Cv","cta":"cta___adGZS"};